"use strict";
exports.__esModule = true;
var react_1 = require("react");
/**
 * Lower level hook which can be used for customizing the resulting state.
 */
function useApolloNetworkStatusReducer(dispatcher, reducer, initialState) {
    var _a = react_1.useReducer(reducer, initialState), status = _a[0], dispatch = _a[1];
    // Effects fire bottom-up. Therefore it's possible that when a query is nested
    // further down the tree than a component using this hook and the query fires
    // on the initial render, we'll miss the request event. Note that this isn't
    // an issue when pre-rendering or fetching on the server side.
    react_1.useEffect(function () {
        var animationFrameId;
        function onDispatch(action) {
            // Apollo fetches data while rendering and therefore invoking a GraphQL
            // request would trigger an update while another component renders. In
            // React@^16.13.1 this triggers a warning. To avoid this, we can handle
            // all network events at the beginning of the next frame.
            animationFrameId = requestAnimationFrame(function () {
                dispatch(action);
            });
        }
        dispatcher.addListener(onDispatch);
        return function () {
            dispatcher.removeListener(onDispatch);
            cancelAnimationFrame(animationFrameId);
        };
    }, [dispatcher]);
    return status;
}
exports["default"] = useApolloNetworkStatusReducer;
